import React, { useEffect, useState } from "react";
import {
  TextField,
  Checkbox,
  Button,
  Typography,
  FormControlLabel,
  Box,
  Stack,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Grid } from '@mui/material';
import image from "../../assets/register.png";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { createUser } from "../../store/userSlice";
import PasswordVisibility from "../../components/Common/PasswordVisibility";
import logo from "../../assets/logo.png"


const Register = () => {
  const [showPassword, setShowPassword] = React.useState({
    password: false,
    confirmPassword: false,
  }); const dispatch = useDispatch()
  const navigate = useNavigate()
  const validationSchema = Yup.object({
    username: Yup.string()
      .required("Username is required")
      .min(3, "Username must be at least 3 characters"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Enter a valid email address"
      ),// Convert to lowercase
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
    terms: Yup.boolean()
      .oneOf([true], "You must agree to the terms and conditions"),
  });
  const formik = useFormik({
    initialValues: {
      username: "",
      email: "",
      password: "",
      terms: false,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.email = values.email.toLowerCase();
      console.log("Form Submitted:", values);
      dispatch(createUser(values)).then((res) => {
        console.log("register res", res);
        if (res?.payload?.status === 201) {
          navigate('/login')
        }
      })
    },
  });
  const togglePasswordVisibility = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };
  const [height, setHeight] = useState('100vh');

  useEffect(() => {
    const updateHeight = () => {
      const isPortrait = window.matchMedia('(orientation: portrait)').matches;
      const width = window.innerWidth;

      // Use width < 768px as "phone"
      if (width < 768) {
        setHeight(isPortrait ? '100vh' : '100%');
        if (!isPortrait && width > 740 && width <= 767) {
          setHeight('100vh')
        }
      } else {
        if (width === 912 || width === 854) {
          setHeight('100vh')
        }
        else if (width <= 932 && width >= 844) {
          setHeight('100%')
        } else {
          setHeight('100vh'); // tablet and larger always 100vh
        }
      }
    };

    updateHeight(); // Run on mount

    window.addEventListener('resize', updateHeight);
    window.addEventListener('orientationchange', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
      window.removeEventListener('orientationchange', updateHeight);
    };
  }, []);
  return (
    <>
      <Box >
        <Grid
          container
          className="d-flex justify-content-center align-items-center gap-3 login-main-wrapper"
          sx={{ height, padding: '20px 0px' }}
        >
          <Box
            component="form"
            onSubmit={formik.handleSubmit}
            className="login-wrapper"
          >
            <Box className="setting-icon mb-1" display={"flex"} justifyContent={"center"} >
              <img src={logo} alt="app-logo" loading="lazy" />
            </Box>
            <Typography variant="h5" gutterBottom className="text-center">
              Sign Up
            </Typography>

            <TextField
              fullWidth
              required
              id="userName"
              name="username"
              label="User Name"
              margin="normal"
              variant="outlined"
              value={formik.values.username}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.username && Boolean(formik.errors.username)}
              helperText={formik.touched.username && formik.errors.username}
            />

            <TextField
              fullWidth
              required
              id="email"
              name="email"
              label="Email"
              type="email"
              margin="normal"
              variant="outlined"
              value={formik.values.email}
              // onChange={formik.handleChange}
              onChange={(e) => {
                const lowerCaseEmail = e.target.value.toLowerCase();
                formik.setFieldValue("email", lowerCaseEmail);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />

            <TextField
              fullWidth
              required
              id="password"
              name="password"
              label="Password"
              type={showPassword.password ? "text" : "password"}
              margin="normal"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <PasswordVisibility
                    showPassword={showPassword.password}
                    onToggle={() => togglePasswordVisibility("password")}
                  />
                ),
              }}
            />
            <TextField
              fullWidth
              required
              id="confirmPassword"
              name="confirmPassword"
              label="Confirm Password"
              type={showPassword.confirmPassword ? "text" : "password"}
              margin="normal"
              variant="outlined"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
              helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
              InputProps={{
                endAdornment: (
                  <PasswordVisibility
                    showPassword={showPassword.confirmPassword}
                    onToggle={() => togglePasswordVisibility("confirmPassword")}
                  />
                ),
              }}
            />
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: '0.8rem',
                marginTop: '0.8rem',
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    name="terms"
                    color="primary"
                    className="pl-0"
                    checked={formik.values.terms}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />}
                label={
                  <Typography variant="body1" className="auth-label-wrapper">
                    I agree to the <Link className="router-link-color" to="/terms-conditions">Terms and Conditions</Link>
                  </Typography>
                }
              />
              {formik.touched.terms && formik.errors.terms && (
                <Typography variant="body2" color="error">
                  {formik.errors.terms}
                </Typography>
              )}
            </Stack>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
            >
              Sign Up
            </Button>

            <Typography variant="body1" className="mt-3 text-center auth-label-wrapper" >
              Already have an account? <Link to="/login" className="router-link-color">Sign In</Link>
            </Typography>
          </Box>
          {/* <Grid item size={{ lg: 3, md: 6, sm: 12, xs: 12 }} className="m-4">
            <Box
              component="form"
              onSubmit={formik.handleSubmit}
            >
              <Typography variant="h4" gutterBottom>
                Sign Up
              </Typography>

              <TextField
                fullWidth
                required
                id="userName"
                name="username"
                label="User Name"
                margin="normal"
                variant="outlined"
                value={formik.values.username}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.username && Boolean(formik.errors.username)}
                helperText={formik.touched.username && formik.errors.username}
              />

              <TextField
                fullWidth
                required
                id="email"
                name="email"
                label="Email"
                type="email"
                margin="normal"
                variant="outlined"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />

              <TextField
                fullWidth
                required
                id="password"
                name="password"
                label="Password"
                type={showPassword.password ? "text" : "password"}
                margin="normal"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <PasswordVisibility
                      showPassword={showPassword.password}
                      onToggle={() => togglePasswordVisibility("password")}
                    />
                  ),
                }}
              />
              <TextField
                fullWidth
                required
                id="confirmPassword"
                name="confirmPassword"
                label="Confirm Password"
                type={showPassword.confirmPassword ? "text" : "password"}
                margin="normal"
                variant="outlined"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                InputProps={{
                  endAdornment: (
                    <PasswordVisibility
                      showPassword={showPassword.confirmPassword}
                      onToggle={() => togglePasswordVisibility("confirmPassword")}
                    />
                  ),
                }}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name="terms"
                    color="primary"
                    checked={formik.values.terms}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />}
                label={
                  <Typography variant="body1">
                    I agree to the <Link className="router-link-color" to="/terms-conditions">Terms and Conditions</Link>
                  </Typography>
                }
              />
              {formik.touched.terms && formik.errors.terms && (
                <Typography variant="body2" color="error">
                  {formik.errors.terms}
                </Typography>
              )}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
              >
                Sign Up
              </Button>

              <Typography variant="body1" className="mt-2" >
                Already have an account? <Link to="/login" className="router-link-color">Sign In</Link>
              </Typography>
            </Box>
          </Grid>
          <Grid item size={{ lg: 4, md: 6, sm: 12, xs: 12 }} >
            <Box
              component="img"
              src={image}
              alt="Register"
              className="register-image"

            />
          </Grid> */}
        </Grid>
      </Box>

    </>
  );
};

export default Register;
